<template>
    <div>
        <ResourcesComponent/>
    </div>
</template>

<script>

import ResourcesComponent from "@/components/ResourcesComponent";

export default {
    name: 'resources-view',
    components: { ResourcesComponent},
    title: 'Resources',
}
</script>

